module.exports = __webpack_public_path__ + "static/media/barbershop.5184f65d.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/barbershop.jpg
// module id = 1819
// module chunks = 0